import { createHttpClient, getStoredAuthToken } from "./client";

const http = createHttpClient();

export function trackAnalyticsEvent(payload) {
  return http.post("/quark/bead/analytics/track", {
    ...payload,
    wxLoginToken: getStoredAuthToken() || undefined
  });
}
